import { unref } from "vue";
import { useI18n } from "vue-i18n";
import { auditContentHtml } from "../domain/contentAuditRules";
const RULE_DISPLAY = {
    MISSING_PREFERENCES_LINK: { icon: "fa-link-slash", i18n: "templating.audit.missingPreferencesLink" },
    UNKNOWN_MERGE_FIELD: { icon: "fa-code", i18n: "templating.audit.unknownMergeField" },
};
/**
 * Turns the shared `auditContentHtml` rules into an Unlayer `Validator` for the editor's Audit tab.
 * Diagnostic only — the send gate is `useCampaignEditorStore.preSendWarnings`.
 */
export function useContentAudit(options) {
    const { t } = useI18n();
    function validator(info) {
        const findings = auditContentHtml(info.html, {
            emailType: unref(options.emailType),
            catalogueKeys: options.catalogueKeys.value,
        });
        const entries = findings.map((finding) => {
            const { icon, i18n } = RULE_DISPLAY[finding.ruleId];
            return {
                // Unlayer keys its audit rows by id, so several unknown tokens need distinct ids or they
                // collapse into a single row naming only one of them.
                id: finding.token ? `${finding.ruleId}:${finding.token}` : finding.ruleId,
                icon,
                severity: "ERROR",
                title: t(`${i18n}.title`),
                // vue-i18n ignores named params a message does not use, so one call serves both shapes.
                description: t(`${i18n}.description`, { token: finding.token ?? "" }),
            };
        });
        return [...entries, ...(info.defaultErrors ?? [])];
    }
    return { validator };
}
